<template>
  <div>
    <div class="panel panel-default padding-left-15 padding-right-15">
      <v-container class="panel-body">
        <v-form id="enrollment-form" ref="enrollment-form" v-model="valid" lazy-validation>
          <v-row>
            <v-col sm="2" cols="7">
              <v-select :items="primaryTypesList" v-model="primaryType" :return-object="false" :rules="[rules.required]" label="Primary Type" required></v-select>
            </v-col>
            <v-col sm="2" cols="5">
              <v-select v-if="canExtended" v-model="primaryDays" :items="[ { text: '24h', value: 1 }, { text: '48h', value: 2 } ]"
                        :return-object="false" :rules="[rules.required]" label="Duration" required></v-select>
              <v-select v-else v-model="primaryDays" :items="primaryType === 'extended' ? [ 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ]
                        : [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30 ]"
                        :return-object="false" :rules="[rules.required]" label="Duration" required></v-select>
            </v-col>
            <v-col sm="7" cols="10">
              <v-combobox :items="isHolter ? holterCodesList : otherCodesList" v-model="primaryIndication"
                        :return-object="false" :rules="[rules.required]" label="Primary Indication" required></v-combobox>
            </v-col>
            <v-col sm="1" cols="2">
              <v-btn v-if="canExtended && !hasExtended" icon @click="hasExtended = true"><v-icon color="#33cc33">mdi-plus-thick</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row v-if="viewExtended">
            <v-col sm="2" cols="7">
              <v-select :items="extendedTypesList" v-model="extendedType" :return-object="false" :rules="[rules.required]" label="Extended Type" required></v-select>
            </v-col>
            <v-col sm="2" cols="5">
              <v-select :items="[ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30 ]"
                        v-model="extendedDays" :rules="[rules.required]" label="Duration" required></v-select>
            </v-col>
            <v-col sm="7" cols="10">
              <v-combobox :items="otherCodesList" v-model="extendedIndication" hide-no-data
                          :return-object="false" :rules="[rules.required]" label="Extended Indication" required></v-combobox>
            </v-col>
            <v-col sm="1" cols="2">
              <v-btn icon @click="hasExtended = false"><v-icon color="#cc3333">mdi-minus</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6" cols="12">
              <v-text-field v-model="serviceStart" :rules="[rules.required]" type="date" label="Start" :disabled="activated"></v-text-field>
            </v-col>
            <v-col sm="6" cols="12">
              <v-autocomplete :items="devicesList" v-model="deviceSerial" hide-selected :rules="[rules.required]"
                              label="Device SN" :disabled="!Array.isArray(devicesList) || devicesList.length <= 1"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-expansion-panels multiple v-model="panels">
              <v-expansion-panel-a id="patient-information">
                <v-expansion-panel-header hide-actions>
                  <span class="header">Patient information</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.firstName" :rules="[rules.required]" label="First name"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.lastName" :rules="[rules.required]" label="Last name"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.address.line1" :rules="[rules.required]" label="Address Line 1"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.address.line2" label="Address Line 2"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.address.city" :rules="[rules.required]" label="City"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-autocomplete :items="statesList" v-model="patient.address.state" hide-no-data label="State"></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.address.zip" label="Zip"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.address.country" label="Country"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.dob" :rules="[rules.required]" type="date" label="Date of birth"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-select v-model="patient.sex" :rules="[rules.required]" label="Sex" :items="sex"></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="patient.phone" :rules="[rules.required]" type="tel" label="Phone"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-checkbox v-model="patient.pacemaker" label="Pacemaker"></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="patient.mrn" type="" label="MRN"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel-a>
              <v-expansion-panel-a id="vaccination">
                  <v-expansion-panel-header disable-icon-rotate @click="toggleVaccination">
                      <span class="header">Vaccination</span>
                      <template v-slot:actions>
                          <v-simple-checkbox class="icon" :value="hasVaccination" @click="toggleVaccination"></v-simple-checkbox>
                      </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <v-row v-for="(e, i) in vaccinations" v-bind:key="e.text">
                          <v-col cols="10">
                              <v-text-field v-model="e.text" :rules="[rules.required_va]" label="Event"></v-text-field>
                          </v-col>
                          <v-col cols="1">
                              <v-text-field v-model="e.times" label="Times"></v-text-field>
                          </v-col>
                          <v-col cols="1"><div class="v-text-field">
                            <v-btn icon cols="1" @click="delVaccination(i)"><v-icon color="#cc3333">mdi-minus</v-icon></v-btn>
                          </div></v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12"><div class="pull-right">
                            <v-btn icon @click="addVaccination()"><v-icon color="#33cc33">mdi-plus-thick</v-icon></v-btn>
                          </div></v-col>
                      </v-row>
                  </v-expansion-panel-content>
              </v-expansion-panel-a>
              <v-expansion-panel id="alternate-contact">
                <v-expansion-panel-header>
                  <span class="header">Alternate contact</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="alternate.firstName" label="First name"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="alternate.lastName" label="Last name"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="alternate.phone" type="tel" label="Phone"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="alternate.relation" label="Relationship"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel-a id="primary-insurance">
                <v-expansion-panel-header disable-icon-rotate @click="togglePrimaryInsurance">
                  <span class="header">Primary insurance</span>
                  <template v-slot:actions>
                    <v-simple-checkbox class="icon" :value="hasPrimaryInsurance" @click="togglePrimaryInsurance"></v-simple-checkbox>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="primaryInsurance.name" :rules="[rules.required_pi]" label="Name"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="primaryInsurance.address" label="Address"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="primaryInsurance.referral" label="Referral"></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="primaryInsurance.id" :rules="[rules.required_pi]" label="ID"></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="primaryInsurance.group" :rules="[rules.required_pi]" label="Group"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel-a>
              <v-expansion-panel-a id="secondary-insurance">
                <v-expansion-panel-header disable-icon-rotate @click="toggleSecondaryInsurance">
                  <span class="header">Secondary insurance</span>
                  <template v-slot:actions>
                    <v-simple-checkbox class="icon" :value="hasSecondaryInsurance" @click="toggleSecondaryInsurance"></v-simple-checkbox>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="secondaryInsurance.name" :rules="[rules.required_si]" label="Name"></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <v-text-field v-model="secondaryInsurance.address" label="Address"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="secondaryInsurance.referral" label="Referral"></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="secondaryInsurance.id" :rules="[rules.required_si]" label="ID"></v-text-field>
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field v-model="secondaryInsurance.group"  :rules="[rules.required_si]" label="Group"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel-a>
              <v-expansion-panel-a id="requesting-physician">
                <v-expansion-panel-header hide-actions>
                  <span class="header">Ordering physician</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col lg="8" cols="12">
                      <v-combobox :items="doctorsList" item-text="name" @change="requestingPhysicianChanged" v-model="requestingPhysicianValue"
                                  label="Name" hide-no-data return-object clearable></v-combobox>
                    </v-col>
                    <v-col lg="4" cols="12">
                      <v-text-field v-model="requestingPhysician.phone" type="tel" label="Phone"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="requestingPhysician.notes" label="Referring Physician"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel-a>
              <v-expansion-panel-a id="primary-physician">
                <v-expansion-panel-header hide-actions>
                  <span class="header">Reading physician</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col lg="8" cols="12">
                      <v-combobox :items="doctorsList" item-text="name" @change="primaryPhysicianChanged" v-model="primaryPhysicianValue"
                                  label="Name" hide-no-data return-object clearable></v-combobox>
                    </v-col>
                    <v-col lg="4" cols="12">
                      <v-text-field v-model="primaryPhysician.phone" type="tel" label="Phone"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea v-model="primaryPhysician.notes" label="Notes"></v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel-a>
            </v-expansion-panels>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12">I authorize the above ordering physician to release any necessary medical or demographic information concerning above named patient to CorVitals Inc.</v-col>
          </v-row>
          <v-row class="form-footer">
            <v-col cols="6"><v-checkbox v-model="termsAccepted" :disabled="submitted" label="I accept terms"></v-checkbox></v-col>
            <v-col cols="6"><div class="pull-right"><v-btn :disabled="!termsAccepted" @click="reviewForm">Submit</v-btn></div></v-col>
          </v-row>
        </v-form>
      </v-container>
    </div>

    <v-dialog v-model="review" max-width="80%" width="60%">
      <v-card>
        <v-card-title class="headline">Enrollment details</v-card-title>
        <v-card-text v-html="reviewText"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#d9534f" large @click="review = false">Edit</v-btn>&nbsp;
          <v-btn color="#46be8a" large @click="submitForm">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { CvConsts } from '../cv-consts.js';

export default {
  name: 'enrollment-form',
  props: {
    route: {
      type: String,
      default: '/request',
    },
    devices: {
      type: Array|String,
      default: () => { return []; }
    },
    doctors: {
      type: Array|String,
      default: () => { return []; }
    },
    stampFormat: {
      type: String,
      default: 'x'
    },
    request: {
      type: Object|String,
      default: () => { return {}; }
    }
  },
  data() {
    return {
      id: null,
      valid: true,
      rules: {
        required: v => !!v || 'Field is required.',
        required_va: v => !this.hasVaccination || !!v || 'Field is required.',
        required_pi: v => !this.hasPrimaryInsurance || !!v || 'Field is required.',
        required_si: v => !this.hasSecondaryInsurance || !!v || 'Field is required.',
        min: v => !v || (v && v.length > 0) || 'Must have at least 1 characters',
      },
      sex: [ '', 'Female', 'Male' ],
      primaryTypesList: CvConsts.PrimaryTestTypes,
      extendedTypesList: CvConsts.ExtendedTestTypes,
      devicesList: [],
      holterCodesList: CvConsts.HolterCodes,
      otherCodesList: CvConsts.OtherCodes,
      statesList: CvConsts.USStates,
      doctorsList: [],
      primaryPhysicianValue: null,
      requestingPhysicianValue: null,
      activated: false,

      primaryType: 'holter',
      primaryIndication: '',
      primaryDays: 1,
      hasExtended: false,
      extendedType: 'wifi',
      extendedIndication: '',
      extendedDays: 1,
      deviceSerial: null,
      serviceStart: '',

      patient: {
        firstName: '',
        lastName: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: '',
          country: 'United States',
        },
        phone: '',
        dob: '',
        sex: '',
        pacemaker: false,
        notes: '',
        tz: new moment().utcOffset(),
        mrn: null,
      },
      alternate: {
        firstName: '',
        lastName: '',
        phone: '',
        relation: ''
      },

      requestingPhysician: {
        name: '',
        phone: '',
        notes: ''
      },
      primaryPhysician: {
        name: '',
        phone: '',
        notes: ''
      },

      hasPrimaryInsurance: false,
      primaryInsurance: {
        name: '',
        address: '',
        referral: '',
        id: '',
        group: ''
      },

      hasSecondaryInsurance: false,
      secondaryInsurance: {
        name: '',
        address: '',
        referral: '',
        id: '',
        group: ''
      },

      hasVaccination: false,
      vaccinations: [],

      termsAccepted: false,

      panels: [ 0, 5, 6 ],  // array of opened panels indexes
      submitted: false,

      review: false,
      reviewText: '',
    }
  },
  methods: {
    openPanel(index) {
      this.panels.push(index)
    },
    closePanel(index) {
      this.panels = this.panels.filter((item) => item !== index);
    },
    setPanelState(index, state) {
      return state ? this.openPanel(index) : this.closePanel(index);
    },
    toggleVaccination() {
        this.hasVaccination = !this.hasVaccination;
    },
    addVaccination() {
        this.vaccinations.push({ text: '', times: 1 });
    },
    delVaccination(id) {
        this.vaccinations.splice(id, 1);
    },
    togglePrimaryInsurance() {
      this.hasPrimaryInsurance = !this.hasPrimaryInsurance;
    },
    toggleSecondaryInsurance() {
      this.hasSecondaryInsurance = !this.hasSecondaryInsurance;
    },
    primaryPhysicianChanged(value) {
      if (typeof value === 'object') {
        this.primaryPhysician.name = (value && 'name' in value) ? value.name : '';
        this.primaryPhysician.phone = (value && 'phone' in value) ? value.phone : '';
      } else if (typeof value === 'string' || value instanceof String) {
        this.primaryPhysician.name = value;
      }
    },
    setPrimaryPhysicianByName(name) {
      this.primaryPhysicianValue = this.doctorsList.find(i => i.name === name);
      if (!this.primaryPhysicianValue) this.primaryPhysicianValue = name;
      this.primaryPhysician.name = name;
    },
    requestingPhysicianChanged(value) {
      if (typeof value === 'object') {
        this.requestingPhysician.name = (value && 'name' in value) ? value.name : '';
        this.requestingPhysician.phone = (value && 'phone' in value) ? value.phone : '';
      } else if (typeof value === 'string' || value instanceof String) {
        this.requestingPhysician.name = value;
      }
    },
    setRequestingPhysicianByName(name) {
      this.requestingPhysicianValue = this.doctorsList.find(i => i.name === name);
      if (!this.requestingPhysicianValue) this.requestingPhysicianValue = name;
      this.requestingPhysician.name = name;
    },
    buildEnrollmentData() {
      const startsAt = new moment(this.serviceStart, 'YYYY-MM-DD');
      const serviceDays = this.primaryDays + (this.viewExtended ? +this.extendedDays : 0);
      const finishesAt = new moment(startsAt).add(serviceDays, 'days');

      let result = {
        primary_type: this.primaryType,
        primary_days: this.primaryDays,
        primary_code: this.primaryIndication,

        monitoring_serial_number: this.deviceSerial,
        monitoring_starts_at: startsAt.format(this.stampFormat),
        monitoring_finishes_at: finishesAt.format(this.stampFormat),

        first_name: this.patient.firstName,
        last_name: this.patient.lastName,
        address_line: this.patient.address.line1,
        address_line_2: this.patient.address.line2,
        city: this.patient.address.city,
        state: this.patient.address.state,
        zip: this.patient.address.zip,
        country: this.patient.address.country,
        phone: this.patient.phone,
        dob: this.patient.dob,
        sex: this.patient.sex,
        notes: this.patient.notes,
        timezone: this.patient.tz,
        is_pacemaker: this.patient.pacemaker ? 'Yes' : 'No',
        mrn: this.patient.mrn,

        kin_first_name: this.alternate.firstName,
        kin_last_name: this.alternate.lastName,
        kin_phone: this.alternate.phone,
        kin_personal_relationship: this.alternate.relation,

        terms: this.termsAccepted,
      };

      if (this.id) {
        result.id = this.id;
      }

      if (this.viewExtended) {
        result.extended_type = this.extendedType;
        result.extended_days = this.extendedDays;
        result.extended_code = this.extendedIndication;
      }

      if (this.hasVaccination) {
          result.vaccinations = this.vaccinations;
      }

      if (this.requestingPhysician.name) {
        result.doctor_last_name = this.requestingPhysician.name;
      }
      if (this.requestingPhysician.phone) {
        result.doctor_phone = this.requestingPhysician.phone;
      }
      if (this.requestingPhysician.notes) {
        result.doctor_notes = this.requestingPhysician.notes;
      }

      if (this.primaryPhysician.name) {
        result.primary_doctor_name = this.primaryPhysician.name;
      }
      if (this.primaryPhysician.phone) {
        result.primary_doctor_phone = this.primaryPhysician.phone;
      }
      if (this.primaryPhysician.notes) {
        result.primary_doctor_notes = this.primaryPhysician.notes;
      }

      if (this.hasPrimaryInsurance) {
        result = _.merge(result, {
          insurance_name: this.primaryInsurance.name,
          insurance_address: this.primaryInsurance.address,
          insurance_referral: this.primaryInsurance.referral,
          insurance_id: this.primaryInsurance.id,
          insurance_group: this.primaryInsurance.group,
        });
      }
      if (this.hasSecondaryInsurance) {
        result = _.merge(result, {
          insurance_second_name: this.secondaryInsurance.name,
          insurance_second_address: this.secondaryInsurance.address,
          insurance_second_referral: this.secondaryInsurance.referral,
          insurance_second_id: this.secondaryInsurance.id,
          insurance_second_group: this.secondaryInsurance.group,
        });
      }

      return result;
    },
    resolveForm() {
      const form = this.$refs['enrollment-form'];
      if (!form) throw new Error('enrollment form not found.');
      if (!form.validate() || !this.termsAccepted) {
        return null;
      }
      return form;
    },
    reviewForm() {
      const form = this.resolveForm();
      if (!form) return false;

      let text = `<pre>Study will start on ${this.serviceStart} with device '${this.deviceSerial}' and include:<br/>`;
      text += `Primary: ${this.primaryType} for ${this.primaryDays} day(s) with '${this.primaryIndication}';<br/>`;
      if (this.viewExtended) {
        text += `Extra: ${this.extendedType} for ${this.extendedDays} day(s) with '${this.extendedIndication}';<br/>`;
      }
      text += '<br/>';

      text += `Patient ${this.patient.firstName} ${this.patient.lastName} was born ${this.patient.dob} and lives at ` +
          `${this.patient.address.line1} ${this.patient.address.line2} in ${this.patient.address.city}/` +
          `${this.patient.address.state}/${this.patient.address.zip}, ${this.patient.address.country}.<br/>` +
          (this.patient.mrn ? `Patient is registered under Medical Number: ${this.patient.mrn}.<br/>` : '') +
          `Patient is ${this.patient.sex}. Contact phone is ${this.patient.phone}.` + (this.patient.pacemaker ? ' Use pacemaker.' : '') + '<br/>';

      if (this.hasVaccination && this.vaccinations.length > 0) {
          text += 'Vaccinations diary.<br/>' +
              this.vaccinations.map(i => {
                  console.log(i);
                  return `${i.text} - ${i.times} time(s)`;
              }).join(';<br/>') + '<br/>';
      }

      if ((this.alternate.firstName || this.alternate.lastName) && this.alternate.phone) {
        text += `Kin: ${this.alternate.firstName} ${this.alternate.lastName} is ${this.alternate.relation} with phone #${this.alternate.phone}.<br/>`;
      }
      if (this.hasPrimaryInsurance) {
        text += `<br/>Primary insurance '${this.primaryInsurance.name}'/ID#${this.primaryInsurance.id}/Group:'${this.primaryInsurance.group}', ${this.primaryInsurance.address}.`;
        if (this.primaryInsurance.referral) text += `<br/>Referral is ${this.primaryInsurance.referral}.`;
      }
      if (this.hasSecondaryInsurance) {
        text += `<br/>Secondary insurance '${this.secondaryInsurance.name}'/ID#${this.secondaryInsurance.id}/Group:'${this.secondaryInsurance.group}', ${this.secondaryInsurance.address}.`;
        if (this.secondaryInsurance.referral) text += `<br/>Referral is ${this.secondaryInsurance.referral}.`;
      }
      text += '<br/>';
      if (this.requestingPhysician.name) {
        text += `Ordering physician is ${this.requestingPhysician.name}, phone #${this.requestingPhysician.phone}.<br/>`;
        if (this.requestingPhysician.notes) text +=`"${this.requestingPhysician.notes}".<br/>`;
      }
      if (this.primaryPhysician.name) {
        text += `Reading physician is ${this.primaryPhysician.name}, phone #${this.primaryPhysician.phone}.<br/>`;
        if (this.primaryPhysician.notes) text +=`"${this.primaryPhysician.notes}".<br/>`;
      }

      this.reviewText = text + '</pre>';
      this.review = true;
    },
    submitForm() {
      this.review = false;

      const form = this.resolveForm();
      if (!form) return false;

      const self = this;
      setTimeout(function () {
        self.submitted = true;
        axios.post(self.route, self.buildEnrollmentData()).then(r => {
          if ('data' in r && 'url' in r.data) return window.open(r.data.url, '_self');

          form.reset();
          self.submitted = false;
        }).catch(console.error)
      }, 100);
      return true;
    },
    loadDevices() {
      if (typeof(this.devices) !== 'string') {
        return this.onDevicesLoaded(this.devices);
      }

      axios.get(this.devices).then(r => {
        this.onDevicesLoaded([ 'Home hookup' ].concat(r.data));
      }).catch(e => {
        console.error(e);
      });
    },
    onDevicesLoaded(data) {
      let v = this.deviceSerial || data.find(i => true);
      if (v && data.indexOf(v) < 0) data = data.concat([ v ]);
      this.devicesList = data;
      this.deviceSerial = v;
    },
    loadDoctors() {
      if (typeof(this.doctors) !== 'string') {
        this.onDoctorsLoaded(this.doctors);
        return;
      }

      axios.get(this.doctors, {}).then(r => {
        this.onDoctorsLoaded(r.data);
      }).catch(e => {
        console.error(e);
      });
    },
    onDoctorsLoaded(data) {
      const pn = this.primaryPhysician.name;
      const rn = this.requestingPhysician.name;
      this.doctorsList = data;
      this.setPrimaryPhysicianByName(pn);
      this.setRequestingPhysicianByName(rn);
    },
    loadEnrollment() {
      if (typeof(this.request) !== 'string')
        return this.onEnrollmentLoaded(this.request);

      axios.get(this.request).then(r => {
        this.onEnrollmentLoaded(r.data);
      }).catch(console.error);
    },
    onEnrollmentLoaded(data) {
      const hasServices = Array.isArray(data.services) && data.services.length > 0;
      if (hasServices) {
        this.activated = data.services.find(i => i.activated) !== undefined;
      } else {
        this.loadDevices();
      }

      if (data.hasOwnProperty('id')) this.id = data.id;
      if (data.hasOwnProperty('primary_type') && data.primary_type) this.primaryType = data.primary_type;
      if (data.hasOwnProperty('primary_days') && data.primary_days) this.primaryDays = data.primary_days;
      if (data.hasOwnProperty('primary_code') && data.primary_code) this.primaryIndication = data.primary_code;
      if (data.hasOwnProperty('extended_type') && data.extended_type) this.extendedType = data.extended_type;
      if (data.hasOwnProperty('extended_days') && data.extended_days) this.extendedDays = data.extended_days;
      if (data.hasOwnProperty('extended_code') && data.extended_code) this.extendedIndication = data.extended_code;
      this.hasExtended = this.extendedType && this.extendedDays && this.extendedIndication;

      if (data.hasOwnProperty('monitoring_serial_number') && data.monitoring_serial_number) {
        if (hasServices) this.devicesList = [ data.monitoring_serial_number ];
        this.deviceSerial = data.monitoring_serial_number;
      }
      if (data.hasOwnProperty('monitoring_starts_at') && data.monitoring_starts_at) {
        this.serviceStart = moment.utc(data.monitoring_starts_at).format('YYYY-MM-DD');
      }

      if (data.hasOwnProperty('first_name') && data.first_name) this.patient.firstName = data.first_name;
      if (data.hasOwnProperty('last_name') && data.last_name) this.patient.lastName = data.last_name;
      if (data.hasOwnProperty('address_line') && data.address_line) this.patient.address.line1 = data.address_line;
      if (data.hasOwnProperty('address_line_2') && data.address_line_2) this.patient.address.line2 = data.address_line_2;
      if (data.hasOwnProperty('city') && data.city) this.patient.address.city = data.city;
      if (data.hasOwnProperty('state') && data.state) this.patient.address.state = data.state;
      if (data.hasOwnProperty('zip') && data.zip) this.patient.address.zip = data.zip;
      if (data.hasOwnProperty('country') && data.country) this.patient.address.country = data.country;
      if (data.hasOwnProperty('phone') && data.phone) this.patient.phone = data.phone;
      if (data.hasOwnProperty('dob') && data.dob) this.patient.dob = moment(data.dob, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      if (data.hasOwnProperty('sex') && data.sex) this.patient.sex = data.sex;
      if (data.hasOwnProperty('notes') && data.notes) this.patient.notes = data.notes;
      if (data.hasOwnProperty('timezone') && data.timezone) this.patient.tz = data.timezone;
      if (data.hasOwnProperty('is_pacemaker')) this.patient.pacemaker = data.is_pacemaker;
      if (data.hasOwnProperty('mrn')) this.patient.mrn = data.mrn;

      if (data.hasOwnProperty('vaccinations') && Array.isArray(data.vaccinations) && data.vaccinations.length > 0) {
          this.vaccinations = data.vaccinations;
          this.hasVaccination = true;
      }

      if (data.hasOwnProperty('kin_first_name') && data.kin_first_name) this.alternate.firstName = data.kin_first_name;
      if (data.hasOwnProperty('kin_last_name') && data.kin_last_name) this.alternate.lastName = data.kin_last_name;
      if (data.hasOwnProperty('kin_phone') && data.kin_phone) this.alternate.phone = data.kin_phone;
      if (data.hasOwnProperty('kin_personal_relationship') && data.kin_personal_relationship) this.alternate.relation = data.kin_personal_relationship;

      if (data.hasOwnProperty('doctor_phone') && data.doctor_phone) this.requestingPhysician.phone = data.doctor_phone;
      if (data.hasOwnProperty('doctor_notes') && data.doctor_notes) this.requestingPhysician.notes = data.doctor_notes;
      if (data.hasOwnProperty('doctor_last_name') && data.doctor_last_name) this.setRequestingPhysicianByName(data.doctor_last_name);

      if (data.hasOwnProperty('primary_doctor_phone') && data.primary_doctor_phone) this.primaryPhysician.phone = data.primary_doctor_phone;
      if (data.hasOwnProperty('primary_doctor_notes') && data.primary_doctor_notes) this.primaryPhysician.notes = data.primary_doctor_notes;
      if (data.hasOwnProperty('primary_doctor_name') && data.primary_doctor_name) this.setPrimaryPhysicianByName(data.primary_doctor_name);

      if (data.hasOwnProperty('insurance_name') && data.insurance_name) this.primaryInsurance.name = data.insurance_name;
      if (data.hasOwnProperty('insurance_address') && data.insurance_address) this.primaryInsurance.address = data.insurance_address;
      if (data.hasOwnProperty('insurance_referral') && data.insurance_referral) this.primaryInsurance.referral = data.insurance_referral;
      if (data.hasOwnProperty('insurance_id') && data.insurance_id) this.primaryInsurance.id = data.insurance_id;
      if (data.hasOwnProperty('insurance_group') && data.insurance_group) this.primaryInsurance.group = data.insurance_group;
      this.hasPrimaryInsurance = (this.primaryInsurance.name || this.primaryInsurance.address || this.primaryInsurance.referral
        || this.primaryInsurance.id || this.primaryInsurance.group);

      if (data.hasOwnProperty('insurance_second_name') && data.insurance_second_name) this.secondaryInsurance.name = data.insurance_second_name;
      if (data.hasOwnProperty('insurance_second_address') && data.insurance_second_address) this.secondaryInsurance.address = data.insurance_second_address;
      if (data.hasOwnProperty('insurance_second_referral') && data.insurance_second_referral) this.secondaryInsurance.referral = data.insurance_second_referral;
      if (data.hasOwnProperty('insurance_second_id') && data.insurance_second_id) this.secondaryInsurance.id = data.insurance_second_id;
      if (data.hasOwnProperty('insurance_second_group') && data.insurance_second_group) this.secondaryInsurance.group = data.insurance_second_group;
      this.hasSecondaryInsurance = (this.secondaryInsurance.name || this.secondaryInsurance.address || this.secondaryInsurance.referral
        || this.secondaryInsurance.id || this.secondaryInsurance.group);
    }
  },
  computed: {
    isHolter() {
      return this.primaryType === 'holter' || this.primaryType === 'extended';
    },
    canExtended() {
      return this.primaryType === 'holter';
    },
    viewExtended() {
      return this.canExtended && this.hasExtended;
    },
  },
  watch: {
    hasVaccination: function (value) {
        this.setPanelState(1, value);
    },
    hasPrimaryInsurance: function (value) {
      this.setPanelState(3, value);
    },
    hasSecondaryInsurance: function (value) {
      this.setPanelState(4, value);
    }
  },
  mounted() {
    this.serviceStart = new moment().format('YYYY-MM-DD');
    this.hasPrimaryInsurance = false;
    this.loadDoctors();
    this.loadEnrollment();
  }
}
</script>

<style scoped>
.header {
  text-align: left;
  font-weight: bold;
}
.form-footer > .col {
  align-self: center;
}
.custom-error {
  color: red;
  text-align: center;
}
</style>

<style lang="css">
#enrollment-form .v-messages__message {
  color: red !important;
}
</style>